import { render, staticRenderFns } from "./DueDateWithVariables.vue?vue&type=template&id=3d3b059e&scoped=true&"
import script from "./DueDateWithVariables.vue?vue&type=script&lang=js&"
export * from "./DueDateWithVariables.vue?vue&type=script&lang=js&"
import style0 from "./DueDateWithVariables.vue?vue&type=style&index=0&id=3d3b059e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d3b059e",
  null
  
)

export default component.exports